import { ReduxState } from '../reducers'

export default {
  5: (state: ReduxState) => {
    return {
      ...state
    }
  },
  4: (state: ReduxState) => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const calcul = { ...(state as unknown as any).calcul }
      Object.keys(calcul || {}).forEach(key => {
        const value = calcul[key]
        if (value && typeof value === 'object' && 'calcul_code' in value) {
          if (!('mode' in value) || value.mode == null) {
            value.mode = 'none'
          }
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return { ...(state as unknown as any), calcul }
    } catch {
      return { ...state }
    }
  },
  3: (state: ReduxState) => {
    return {
      ...state
    }
  }
}
